import type { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

import { Text } from '@actual-app/components/text';
import { View } from '@actual-app/components/view';

import { BotonRedondo } from '#components/mobile/ui/Cabecera';
import { color, espacio, texto } from '#components/mobile/ui/tokens';
import { useNavigate } from '#hooks/useNavigate';

/** Cabecera de las pantallas de nómina: volver, título, subtítulo y acción. */
export function CabeceraNomina({
  titulo,
  subtitulo,
  derecha,
}: {
  titulo: ReactNode;
  subtitulo?: ReactNode;
  derecha?: ReactNode;
}) {
  const { t } = useTranslation();
  const navigate = useNavigate();
  return (
    <View
      style={{
        flexDirection: 'row',
        alignItems: 'center',
        gap: espacio.fila,
        padding: `6px ${espacio.margen}px`,
        minHeight: 56,
      }}
    >
      <BotonRedondo
        icono="cl"
        aria-label={t('Back')}
        onPress={() => void navigate(-1)}
      />
      <View style={{ flex: 1, minWidth: 0 }}>
        <Text
          role="heading"
          aria-level={1}
          style={{ ...texto.titulo, color: color.fg }}
        >
          {titulo}
        </Text>
        {subtitulo && (
          <Text style={{ fontSize: 13, fontWeight: 700, color: color.fg3 }}>
            {subtitulo}
          </Text>
        )}
      </View>
      {derecha}
    </View>
  );
}
